// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"mG","cardInnerHeading":"mH","toggleWrapperClass":"mI","passwordProtection":"mJ mI","textWrapperClass":"mK","toggleTextClass":"mL"};